import moment from 'moment';

const dateTimeFormat = 'MM/DD/YYYY h:mm A';

export const dateTimePickerFormat = 'MM/dd/yyyy h:mm tt';
export const datePickerFormat = 'MM/DD/YYYY';

export const utcToLocalTimeString = (utcDate) => {
  return moment.utc(utcDate).local().format(dateTimeFormat);
};

export const toTimeString = (date, abbr, format = dateTimeFormat) => {
  return moment.parseZone(date).format(format) + ` ${abbr}`;
};

export const toDate = (date) => {
  return new Date(moment.parseZone(date).format(dateTimeFormat));
};

export const utcDateString = (utcDate) => {
  return moment.utc(utcDate).format(datePickerFormat);
};

export const toDateString = (date) => {
  return moment(date).format('YYYY-MM-DDT00:00:00');
}


// WEBPACK FOOTER //
// src/utils/dates.js